module.exports = __webpack_public_path__ + "media/packs/landing_page/images/studios/beatforce-4ac8b88dec88d1ec459e1c36e0958d3c.png";